import { render, staticRenderFns } from "./PointExplorerTable.vue?vue&type=template&id=0864bafb&scoped=true"
import script from "./PointExplorerTable.vue?vue&type=script&lang=js"
export * from "./PointExplorerTable.vue?vue&type=script&lang=js"
import style0 from "./PointExplorerTable.vue?vue&type=style&index=0&id=0864bafb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864bafb",
  null
  
)

export default component.exports